export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/info.ba728c54.worker.js");
}
